(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lbc-atelier"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAt(root){
    if(!root||root.getAttribute('data-lbc-at-init'))return;
    root.setAttribute('data-lbc-at-init','1');
    var steps=root.querySelector('.lbc-at-steps');
    if(!steps||!('IntersectionObserver' in window))return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    steps.classList.add('is-pending');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){steps.classList.remove('is-pending');io.disconnect();}});},{threshold:.2});
    io.observe(steps);
  }
  function boot(){document.querySelectorAll('[data-lbc-at]').forEach(initAt);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  document.addEventListener('shopify:section:load',function(e){initAt(e.target.querySelector('[data-lbc-at]'));});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbc-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCol(root){
    if(!root||root.getAttribute('data-lbc-init'))return;
    root.setAttribute('data-lbc-init','1');
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        /* Onglets pop culture */
    var tabs=[].slice.call(root.querySelectorAll('.lbc-tabs [role="tab"]')),fx=root.querySelector('.lbc-tabfx');
    function playFx(name){if(!fx||reduce)return;fx.className='lbc-tabfx';void fx.offsetWidth;if(name)fx.classList.add('play-'+name);}
    function select(t,focus){
      tabs.forEach(function(x){var on=x===t;x.setAttribute('aria-selected',on?'true':'false');x.tabIndex=on?0:-1;var p=root.querySelector('#'+x.getAttribute('aria-controls'));if(p)p.hidden=!on;});
      if(focus)t.focus();playFx(t.getAttribute('data-fx'));
    }
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(){select(t);});
      t.addEventListener('keydown',function(e){var k=e.key,j=-1;if(k==='ArrowRight')j=(i+1)%tabs.length;if(k==='ArrowLeft')j=(i-1+tabs.length)%tabs.length;if(k==='Home')j=0;if(k==='End')j=tabs.length-1;if(j>-1){e.preventDefault();select(tabs[j],true);}});
    });
    if(tabs.length)playFx(tabs[0].getAttribute('data-fx'));
    /* Clin d'œil pour les fans : code clavier sur la page pop culture */
    if(root.classList.contains('lbc-m-pop')&&!window.__lbcKc){
      window.__lbcKc=true;
      var KC=['arrowup','arrowup','arrowdown','arrowdown','arrowleft','arrowright','arrowleft','arrowright','b','a'],pos=0,busy=false;
      var flag='<svg class="fl-w" viewBox="0 0 8 10" width="16" height="20" shape-rendering="crispEdges" aria-hidden="true"><rect x="1" y="0" width="1" height="10" fill="#c8d2e1"/><g class="fl"><rect x="2" y="1" width="5" height="1" fill="#4ade80"/><rect x="2" y="2" width="4" height="1" fill="#4ade80"/><rect x="2" y="3" width="5" height="1" fill="#4ade80"/></g></svg>';
      var checkpoint=function(){
        if(busy)return;busy=true;
        var b=document.createElement('div');b.className='lbc-cp';b.setAttribute('role','status');b.innerHTML=flag+'<span>CHECKPOINT</span>';
        document.body.appendChild(b);void b.offsetWidth;b.classList.add('on');
        if(!reduce){root.classList.remove('lbc-flick');void root.offsetWidth;root.classList.add('lbc-flick');}
        setTimeout(function(){b.classList.remove('on');setTimeout(function(){if(b.parentNode)b.parentNode.removeChild(b);busy=false;},400);},3000);
      };
      document.addEventListener('keydown',function(e){
        var el=e.target;if(el&&(el.isContentEditable||/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)))return;
        var k=(e.key||'').toLowerCase();
        if(k===KC[pos]){pos++;if(pos===KC.length){pos=0;checkpoint();}}else{pos=(k===KC[0])?1:0;}
      });
    }
  }
  function boot(){document.querySelectorAll('[data-lbc-col]').forEach(initCol);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  document.addEventListener('shopify:section:load',function(e){initCol(e.target.querySelector('[data-lbc-col]'));});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbc-vitrine"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initLbc(root){
    if(!root||root.getAttribute('data-lbc-init'))return;
    root.setAttribute('data-lbc-init','1');
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine=window.matchMedia('(hover: hover)').matches;
    var vids=[].slice.call(root.querySelectorAll('video'));
    vids.forEach(function(v){v.muted=true;v.loop=true;v.setAttribute('playsinline','');v.removeAttribute('controls');});
    function start(){vids.forEach(function(v){var p=v.play();if(p&&p.catch)p.catch(function(){});});}
    if(reduce){root.classList.remove('lbc-off');return;}
    var fired=false;
    function on(){if(fired)return;fired=true;setTimeout(function(){root.classList.remove('lbc-off');start();},450);}
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){on();io.disconnect();}});},{threshold:.25});
      io.observe(root);
    }else{on();}
    document.addEventListener('visibilitychange',function(){if(document.hidden)vids.forEach(function(v){v.pause();});else if(fired)start();});
    var pop=root.querySelector('.lbc-door--pop');
    if(pop&&fine){
      var cv=pop.querySelector('.lbc-px'),st=pop.querySelector('.lbc-stage'),src=st.querySelector('.lbc-main'),ctx=cv.getContext('2d'),off=document.createElement('canvas'),oc=off.getContext('2d'),run=0;
      function ready(){if(!src)return false;if(src.tagName==='VIDEO')return src.readyState>=2;if(src.tagName==='IMG')return src.complete&&src.naturalWidth>0;return false;}
      pop.addEventListener('mouseenter',function(){
        var id=++run,W=st.clientWidth,H=st.clientHeight,steps=[30,20,12,7,4],i=0;
        cv.width=W;cv.height=H;ctx.imageSmoothingEnabled=false;
        (function frame(){
          if(id!==run)return;
          if(i>=steps.length||!ready()){cv.style.transition='opacity .18s ease';cv.style.opacity=0;return;}
          var b=steps[i++],w=Math.max(1,Math.round(W/b)),h=Math.max(1,Math.round(H/b));
          off.width=w;off.height=h;
          try{oc.drawImage(src,0,0,w,h);ctx.drawImage(off,0,0,w,h,0,0,W,H);cv.style.transition='none';cv.style.opacity=1;}catch(e){cv.style.opacity=0;return;}
          setTimeout(frame,65);
        })();
      });
      pop.addEventListener('mouseleave',function(){run++;cv.style.opacity=0;});
    }
  }
  function boot(){document.querySelectorAll('[data-lbc-vitrine]').forEach(initLbc);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  document.addEventListener('shopify:section:load',function(e){initLbc(e.target.querySelector('[data-lbc-vitrine]'));});
})();

  } catch(e) { console.error(e); }
})();
})();
